var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "has-text-centered container azSize" }, [
    _c("br"),
    _c("br"),
    _vm._v("\n    ADD WORD"),
    _c("br"),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.toAdd,
          expression: "toAdd"
        }
      ],
      staticClass: "input is-warning",
      staticStyle: { width: "200px" },
      attrs: { id: "inp", type: "text" },
      domProps: { value: _vm.toAdd },
      on: {
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.toAdd = $event.target.value
        }
      }
    }),
    _c("br"),
    _vm._v(" "),
    _c(
      "button",
      {
        ref: "addField",
        staticClass: "button is-small is-warning top10",
        attrs: { id: "add" },
        on: { click: _vm.doAdd }
      },
      [_vm._v("ADD")]
    ),
    _vm._v(" "),
    _c("br"),
    _c("br"),
    _c("br")
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9a5ff9a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a5ff9a8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AddWords.vue
// module id = null
// module chunks = 